
export class InputConstants {
    static stext = "string";
    static password = "password";
    static text = "text";
    static number = "number"
}
